'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var common = {
  black: '#000',
  white: '#fff'
};

exports.default = common;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/colors/common.js
// module id = 434
// module chunks = 168707334958949